import React from "react";
import fieldPropTypes from "./field-prop-types";
import { MessagingContext } from "../context/messaging-layer";

const Options = ({
  options,
  selection,
  components: { Radio },
  onChange,
  fieldsName
}) => {
  return options
    .filter(option => option.text)
    .map((option, index) => (
      <Radio
        name={option.name}
        key={option.name}
        label={option.text}
        value={option.value}
        checked={option.value === selection}
        onChange={() => onChange(option)}
        index={index}
        fieldsName={fieldsName}
      />
    ));
};

class CellWithSubtitle extends React.Component {
  handleControlCheck = () => {
    const {
      field: { name, options, title, text },
      components,
      appData: { values, settings }
    } = this.props;
    this.context.showDialog({
      actions: [
        {
          label: settings.translations.cancel,
          className: "secondary",
          name: "close-dialog"
        }
      ],
      content: {
        title: [title, <br key={title} />, <small key={text}>{text}</small>],
        children: (
          <Options
            fieldsName='cellWithCheck'
            options={options}
            selection={values[name]}
            components={components}
            onChange={this.handleOptionCheck}
          />
        )
      }
    });
  };

  handleOptionCheck = ({ value }) => {
    const {
      field: { name },
      appData: { handleChange }
    } = this.props;
    handleChange({ [name]: value });
    setTimeout(this.context.hideDialog, 100); // to allow browser to paint chosen option
  };

  isActive() {
    const {
      field: { name },
      appData: { values }
    } = this.props;

    return values[name] === "Y";
  }

  render() {
    const {
      field: { name, title, text, options },
      components: { Text }
    } = this.props;

    return (
      <Text
        label={[
          <span key='cell-title' className='cell-title'>
            {title}
          </span>,
          <br key={title} />,
          text
        ]}
        name={name}
        params={this.isActive() ? "active" : "websdk-text-gray-500"}
        onClick={options?.length ? this.handleControlCheck : null}
      />
    );
  }
}

CellWithSubtitle.propTypes = fieldPropTypes;
CellWithSubtitle.contextType = MessagingContext;

export default CellWithSubtitle;
